import React, { useState, useEffect } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";

const ReminderTypeList = () => {
    const { http } = AuthUser();
    const [reminderTypes, setReminderTypes] = useState([]);
    const [formData, setFormData] = useState({ name: '' });
    const [editingType, setEditingType] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchReminderTypes();
    }, []);

    const fetchReminderTypes = async () => {
        try {
            const response = await http.get('/reminder_types');
            if (response.data.success) {
                setReminderTypes(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching reminder types:", error);
            toast.error("Error loading reminder types");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || formData.name.trim() === '') {
            toast.error("Name is required");
            return;
        }

        setIsLoading(true);

        try {
            let response;
            if (editingType) {
                response = await http.put(`/reminder_types/${editingType.id}`, formData);
                toast.success("Reminder type updated successfully!");
            } else {
                response = await http.post('/reminder_types', formData);
                toast.success("Reminder type created successfully!");
            }

            if (response.data.success) {
                setShowModal(false);
                setFormData({ name: '' });
                setEditingType(null);
                fetchReminderTypes();
            }
        } catch (error) {
            console.error("Error saving reminder type:", error);
            const errorMessage = error.response?.data?.message || "Error saving reminder type";
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (type) => {
        setEditingType(type);
        setFormData({ name: type.name });
        setShowModal(true);
    };

    const handleAddNew = () => {
        setEditingType(null);
        setFormData({ name: '' });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingType(null);
        setFormData({ name: '' });
    };

    const filteredTypes = reminderTypes.filter(type =>
        type.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="container-fluid mt-4">
            <Toaster />

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Reminder Type Master</h5>
                            <button className="btn btn-sm btn-primary" onClick={handleAddNew}>
                                <i className="fas fa-plus-circle me-1"></i> Add Reminder Type
                            </button>
                        </div>
                        <div className="card-body">
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by name..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Created At</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredTypes.length > 0 ? (
                                            filteredTypes.map((type) => (
                                                <tr key={type.id}>
                                                    <td>{type.id}</td>
                                                    <td>{type.name}</td>
                                                    <td>{new Date(type.created_at).toLocaleDateString()}</td>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <button
                                                            className="btn btn-sm btn-warning me-1"
                                                            onClick={() => handleEdit(type)}
                                                            style={{ fontSize: '11px', padding: '5px 10px' }}
                                                            title="Edit"
                                                        >
                                                            <i className="fas fa-pen"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">No reminder types found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {editingType ? 'Edit Reminder Type' : 'Add New Reminder Type'}
                                </h5>
                                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Name <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Saving...
                                            </>
                                        ) : (
                                            'Save'
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReminderTypeList;
